export default class NavigationMenuMobile {
  constructor(component) {
    this.dom = {
      $component: component,
      $mobileNav: component,
      $body: document.querySelector('body'),
      $navigation: document.querySelector('.js-navigation'),
      $mobileNavUnderlay: document.querySelector('.js-mobileNavUnderlay'),
      $mobileNavToggle: document.querySelectorAll('.js-toggleMobileNav'),
      $navMenuBtns: component.querySelectorAll('.js-navMenuOpen'),
      $backBtns: component.querySelectorAll('.js-menuBack')
    }
    this.state = {
      mobileNavOpen: false,
      openSubMenu: '',
      mobileNavOpenClass: 'openMobileNav',
      underlayActiveClass: 'isActive',
      bodyFixedClass: 'bodyFixed',
      subMenuClass: '.js-navSubContainerMobile',
      subMenuActiveClass: 'active',
      searchActiveClass: 'searchActive'
    }
    this.toggleMobileNavHandler = this.toggleMobileNav.bind(this)
    this.openSubMenuHandler = this.openSubMenu.bind(this)
    this.closeSubMenuHandler = this.closeSubMenu.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {dom} = this
    dom.$mobileNavToggle.forEach($toggle => $toggle.addEventListener('click', this.toggleMobileNavHandler))
    dom.$navMenuBtns.forEach($btn => $btn.addEventListener('click', this.openSubMenuHandler))
    dom.$backBtns.forEach($btn => $btn.addEventListener('click', this.closeSubMenuHandler))
  }

  toggleMobileNav() {
    const {dom, state} = this

    if (state.mobileNavOpen) {
      dom.$mobileNav.setAttribute('aria-hidden', 'true')
      dom.$mobileNav.setAttribute('aria-expanded', 'false')
      dom.$navigation.classList.remove(state.mobileNavOpenClass)
      dom.$mobileNavUnderlay.classList.remove(state.underlayActiveClass)
      dom.$body.classList.remove(state.bodyFixedClass)
      state.mobileNavOpen = false

      if (dom.$mobileNav.classList.contains(state.searchActiveClass)) {
        setTimeout(() => {
          dom.$mobileNav.classList.remove(state.searchActiveClass)
        }, 500)
      }

      if (state.openSubMenu) {
        const subMenuClass = `${state.subMenuClass}[data-url="${state.openSubMenu}"]`
        setTimeout(() => {
          dom.$component.querySelector(subMenuClass).classList.remove(state.subMenuActiveClass)
          state.openSubMenu = ''
        }, 500)
      }
    } else {
      dom.$mobileNav.setAttribute('aria-hidden', 'false')
      dom.$mobileNav.setAttribute('aria-expanded', 'true')
      dom.$navigation.classList.add(state.mobileNavOpenClass)
      dom.$mobileNavUnderlay.classList.add(state.underlayActiveClass)
      dom.$body.classList.add(state.bodyFixedClass)
      state.mobileNavOpen = true
    }
  }

  openSubMenu(e) {
    const {dom, state} = this
    const subMenuUrl = e.currentTarget.dataset.url
    const subMenuClass = `${state.subMenuClass}[data-url="${subMenuUrl}"]`
    dom.$component.querySelector(subMenuClass).classList.add(state.subMenuActiveClass)
    state.openSubMenu = subMenuUrl
  }

  closeSubMenu() {
    const {dom, state} = this
    const subMenuClass = `${state.subMenuClass}[data-url="${state.openSubMenu}"]`
    dom.$component.querySelector(subMenuClass).classList.remove(state.subMenuActiveClass)
    state.openSubMenu = ''
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.NavigationMenuMobile = this
  }
}
